import React from 'react'
import { RouteApi } from '../api/RouteApi'
import Auth from 'live/services/authorization'
import MenuService from 'live/services/menu'
import { ExtensionInstance } from '../type'

import { Dropdown, MenuItem } from 'react-bootstrap'
import styled from 'styled-components'

const routesApi = new RouteApi()

const closeDropdown = (): void => {
    document.querySelectorAll('.navbar #main-navigation .dropdown ')?.forEach(e => e?.classList?.remove('open'))
}

type Rule = {
    id: string
    ruleType: string
    ruleContent: string
    homePageKey: string
    showHomeMenu: boolean
    homeMenuLabel: string
}
;(async () => {
    // Get the home-page rules from the Live settings
    const data = await fetch('/rest/ui/home-page')
        .then(res => res.json())
        .then(data => data?.rules)

    let pageWithSamePerspective = {} as Rule

    if (Auth?.accessAllPerspectives) {
        // Get the first page registered in the Live settings home-page, because we follow the hierarchy of the pages
        pageWithSamePerspective = data[0]
    } else {
        // Get the page that the user has access to
        pageWithSamePerspective = data?.find(d => Auth?.accessedPerspectives?.includes(+d?.ruleContent))
    }

    if (!pageWithSamePerspective) {
        console.warn('Current user does not have access to the same perspective page')

        return
    }

    const extensionIntances = await routesApi.getAll()

    const instance = {} as ExtensionInstance

    // Get the navbar and page configuration from the extension instance
    extensionIntances?.forEach(ei =>
        Object.keys(ei)?.forEach(k => {
            if (ei[k]?.defineNavbar && ei[k]?.pageType === pageWithSamePerspective?.homePageKey) {
                Object.assign(instance, ei[k])
            }
        })
    )

    if (!instance?.navbar || instance?.navbar?.length === 0) {
        return
    }

    for (const navbar of instance?.navbar) {
        if (navbar?.subItems?.length === 0) {
            const RoutesMenu = (): JSX.Element => {
                return (
                    <li role="presentation" className="navigation">
                        <a href={`/#/dashboard/${navbar?.dashboardId}`} key="FleetTracking">
                            <span className="nav-link">{navbar?.title}</span>
                        </a>
                    </li>
                )
            }

            const navItemRoutesMenu = {
                alias: 'routesMenu',
                selectedAliases: ['routesMenu'],
                Component: RoutesMenu,
                name: 'Test',
                order: 0.6,
                url: '/#/routes',
                config: {
                    showOnMobile: false
                }
            }
            MenuService.register(navItemRoutesMenu, 'regular')
        } else {
            const SmartMobilityMenu = (): JSX.Element => {
                return (
                    <li role="presentation" className="navigation">
                        <StyledMenuItem role="presentation" className="navigation custom-dropdownMenu">
                            <Dropdown id="live-configurations-menu-entry">
                                <Dropdown.Toggle>{navbar.title}</Dropdown.Toggle>
                                <Dropdown.Menu
                                    className="dropdown-menu"
                                    aria-labelledby="live-configurations-menu-entry"
                                >
                                    <div key="Smart Mobility">
                                        {navbar?.subItems?.map((nb, index) => {
                                            return (
                                                <>
                                                    {nb?.title && (
                                                        <MenuItem
                                                            key={index}
                                                            role="heading"
                                                            header
                                                            className="dropdown-header"
                                                            href={`/#/dashboard/${nb?.dashboardId}`}
                                                            onClick={closeDropdown}
                                                        >
                                                            {nb?.title}
                                                        </MenuItem>
                                                    )}
                                                    <MenuItem
                                                        key={index}
                                                        href={`/#/dashboard/${nb?.dashboardId}`}
                                                        onClick={closeDropdown}
                                                    >
                                                        {nb?.item}
                                                    </MenuItem>
                                                </>
                                            )
                                        })}
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </StyledMenuItem>
                    </li>
                )
            }

            const navItemRoutesMenu = {
                alias: 'routesMenu',
                selectedAliases: ['routesMenu'],
                Component: SmartMobilityMenu,
                name: 'Test',
                order: 0.6,
                url: '/#/routes',
                config: {
                    showOnMobile: false
                }
            }
            MenuService.register(navItemRoutesMenu, 'regular')
        }
    }
})()

const StyledMenuItem = styled.div`
    && {
        &.selected,
        &:hover {
            .dropdown-toggle {
                color: white;
            }
        }

        .dropdown-toggle {
            background-color: transparent;
            border-color: transparent;
            color: #37a3ef;
        }

        .withoutHeader {
            padding-top: 20px;
        }

        ul {
            margin-top: 1px;
            border: 0;
            border-radius: 0;
            min-width: 180px;
            padding: 0 0 20px 0;

            div > li {
                &[role='heading'] {
                    padding: 10px 30px;
                    font-size: 14px;
                    color: #606a80;
                    font-family: 'SourceSansPro-Semibold', Arial, 'Helvetica Neue', Helvetica, sans-serif;
                    text-transform: uppercase;
                }
                > a {
                    padding: 3px 30px;
                    font-size: 13px;
                    color: #37a3ef;
                    text-transform: capitalize;
                    width: 200px;
                    display: flex;
                }

                &[role='presentation']:hover {
                    background-color: #f5f5f5;
                }
            }
            /* div > li:hover{
                background-color-red;
                } */
        }
    }
`
